import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { Box, Paper } from '@mui/material';
import { useLangFile, useLanguage } from 'js/context/LanguageContext';

import { DATE_FORMAT_LONG_DANISH, DATE_FORMAT_LONG_ENGLISH } from 'js/reducers/LanguageReducer';
import { StaticDatePicker, StaticTimePicker } from '@mui/x-date-pickers';
import moment from 'moment';

const DateTimePicker = ({
  date,
  setDate,
  maxDate,
  maxDateMessage,
  minDate,
  minDateMessage,
  minutesStep,
}) => {
  const LangFile = useLangFile();
  const language = useLanguage();

  const dateFormat =
    language === 'da' ? DATE_FORMAT_LONG_DANISH.picker : DATE_FORMAT_LONG_ENGLISH.picker;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      <Box
        sx={{
          pr: 1,
        }}
      >
        <Paper elevation={2}>
          <StaticDatePicker
            label={LangFile.DateTimePicker.date}
            format={dateFormat}
            value={date ? moment(date) : null}
            onChange={setDate}
            maxDate={maxDate ? moment(maxDate) : undefined}
            minDate={minDate ? moment(minDate) : undefined}
          />
        </Paper>
      </Box>
      <Box>
        <Paper elevation={2}>
          <StaticTimePicker
            label={LangFile.DateTimePicker.time}
            ampm={false}
            minutesStep={minutesStep}
            maxDate={maxDate ? moment(maxDate) : undefined}
            minDate={minDate ? moment(minDate) : undefined}
            value={date ? moment(date) : null}
            onChange={setDate}
          />
        </Paper>
      </Box>
    </Box>
  );
};

DateTimePicker.propTypes = {
  date: PropTypes.object,
  setDate: PropTypes.func,
  maxDate: PropTypes.object,
  minDate: PropTypes.object,
  minDateMessage: PropTypes.string,
  maxDateMessage: PropTypes.string,
  minutesStep: PropTypes.number,
};

DateTimePicker.defaultProps = {
  setDate: () => {},
  minutesStep: 1,
};

export default memo(DateTimePicker);
